import { Disclosure, Transition } from '@headlessui/react';
import classNames from '@utils/ClassNames';
import SvgChevronDown from '@components/icons/ChevronDown';
import SvgChevronUp from '@components/icons/ChevronUp';

interface DisclosureElementDescriptionProps {
  headline: string;
  sublines: Array<{
    title: string;
    href: string;
  }>;
  buttonClassName?: string;
}

export const DisclosureElement = ({
  headline,
  sublines,
  buttonClassName,
}: DisclosureElementDescriptionProps) => (
  <Disclosure>
    {({ open }) => (
      <>
        {sublines.length > 1 ? (
          <>
            <Disclosure.Button
              className={classNames(
                buttonClassName,
                'text-h-16 flex justify-between items-center text-left hover:text-dark-secondary',
              )}
            >
              {headline}
              {open ? (
                <SvgChevronUp className="w-6 h-6 flex-0" />
              ) : (
                <SvgChevronDown className="w-6 h-6 flex-0" />
              )}
            </Disclosure.Button>
            <Transition
              show={open}
              enter="transition duration-300 ease-out"
              enterFrom="transform opacity-0"
              enterTo="transform opacity-100"
              leave="transition duration-75 ease-out"
              leaveFrom="transform opacity-100"
              leaveTo="transform opacity-0"
            >
              <Disclosure.Panel className="text-p-14 gap-y-8 flex flex-col">
                {sublines.map((subline) => (
                  <button
                    className="text-left"
                    key={subline.href + subline.title}
                    onClick={() =>
                      scrollTo({
                        top: (document.getElementById(subline.href)?.offsetTop ?? 0) + 100,
                        behavior: 'smooth',
                      })
                    }
                  >
                    {subline.title}
                  </button>
                ))}
              </Disclosure.Panel>
            </Transition>
          </>
        ) : (
          <button
            onClick={() => {
              scrollTo({
                top: document.getElementById(sublines[0]?.href)?.offsetTop ?? 0,
                behavior: 'smooth',
              });
            }}
            className={classNames(buttonClassName, 'text-h-16 text-left hover:text-dark-secondary')}
          >
            {headline}
          </button>
        )}
      </>
    )}
  </Disclosure>
);
